import { paths } from "src/routes/paths";

// API
// ----------------------------------------------------------------------
export const PLATFORM_ENV = import.meta.env.VITE_PLATFORM_ENV;
export const HOST_API = import.meta.env.VITE_HOST_API;
export const BRANDNAME = import.meta.env.VITE_BRANDNAME;
export const PUBLIC_STATIC_URL = import.meta.env.VITE_PUBLIC_STATIC_URL;
export const APP_URL = import.meta.env.VITE_APP_URL;
//export const ASSETS_API = import.meta.env.VITE_ASSETS_API;
export const ASSETS_API = "/public/";
// Preserve the existing public measurement ID moved from index.html.
export const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || "G-TQEL1PRF8H";
export const META_PIXEL_ID = import.meta.env.VITE_META_PIXEL_ID;
export const FIREBASE_API = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APPID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export const AMPLIFY_API = {
  userPoolId: import.meta.env.VITE_AWS_AMPLIFY_USER_POOL_ID,
  userPoolWebClientId: import.meta.env.VITE_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID,
  region: import.meta.env.VITE_AWS_AMPLIFY_REGION,
};

export const AUTH0_API = {
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  callbackUrl: import.meta.env.VITE_AUTH0_CALLBACK_URL,
};

export const MAPBOX_API = import.meta.env.VITE_MAPBOX_API;

// ROOT PATH AFTER LOGIN SUCCESSFUL
//export const PATH_AFTER_LOGIN = paths.dashboard.root; // as '/dashboard'
export const PATH_AFTER_LOGIN = paths.player.activities; // as '/public
